export const SET_SELECTED_VPS = 'SET_SELECTED_VPS';
export const SET_SELECTED_VNC = 'SET_SELECTED_VNC';